import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './estilos.css'

// La app se deja abierta durante toda la jornada. El registro inyectado por
// defecto no recargaba la pestaña cuando un worker nuevo tomaba control, y se
// podía seguir viendo el bundle anterior después de un deploy. Este registro
// comprueba al abrir/volver a la app y recarga una sola vez al cambiar de worker.
if ('serviceWorker' in navigator) {
  let recargando = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recargando) return
    recargando = true
    window.location.reload()
  })
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((registro) => {
      const buscarActualizacion = () => {
        if (document.visibilityState === 'visible' && navigator.onLine) void registro.update()
      }
      document.addEventListener('visibilitychange', buscarActualizacion)
      window.addEventListener('online', buscarActualizacion)
      buscarActualizacion()
    })
  })
}

const raiz = document.getElementById('root')
if (!raiz) throw new Error('Falta #root en index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
